export const customFunctions = {
    Math: Math,
    Number: Number,
    log: function () {
        console.log('you are logging from an AG grid function', ...arguments);
    },
};
